@if (countdown(); as left) {
  <!-- Folded pill: stays in the header flow (it sizes the slot), hidden under the unfolded panel. -->
  <button #pill type="button" class="trial-card trial-header" [class.covered]="expanded()"
    [attr.aria-expanded]="expanded()" (click)="open()">
    <ng-container *ngTemplateOutlet="header; context: {left}"></ng-container>
  </button>

  @if (expanded()) {
    <div class="trial-card trial-panel">
      <button #panelHeader type="button" class="trial-header" aria-expanded="true" (click)="close()">
        <ng-container *ngTemplateOutlet="header; context: {left}"></ng-container>
      </button>
      <div class="trial-body">
        <div class="trial-progress">
          <div class="trial-progress-track">
            <div class="trial-progress-fill" [style.width.%]="elapsedPercent()"></div>
          </div>
          <img [src]="moodIcon()" alt="" class="trial-mood">
        </div>
        <p class="trial-warning">{{ 'menu.trial.warning' | translate }}</p>
        <button type="button" class="trial-contact" (click)="contactSales()">
          <img src="assets/icons/message-text-circle-02.svg" alt="" class="trial-contact-icon">
          {{ 'menu.trial.contactSales' | translate }}
        </button>
      </div>
    </div>
  }
}

<ng-template #header let-left="left">
  <img src="assets/icons/clock-stopwatch.svg" alt="" class="trial-clock">
  <span class="trial-titles">
    <span class="trial-label">{{ 'menu.trial.label' | translate }}</span>
    <span class="trial-days">{{ left.key | translate: {count: left.count} }}</span>
  </span>
  <span class="trial-days-short">{{ left.shortKey | translate: {count: left.count} }}</span>
  <img src="assets/icons/chevron-right.svg" alt="" class="trial-chevron">
</ng-template>
